import React from 'react';
import PropTypes from 'prop-types';
import AttachMoneyOutlined from '@material-ui/icons/AttachMoneyOutlined';
import MoneyOffOutlined from '@material-ui/icons/MoneyOffOutlined';

class AvailableBudget extends React.PureComponent {
    render() {
        return (
            <div className="budgetRemaining">
                <div>
                    {
                        this.props.availableBudget &&
                            parseFloat(this.props.availableBudget) > 0 ?
                                <AttachMoneyOutlined /> :
                                <MoneyOffOutlined />
                    }
                </div>
                <div>Available Budget</div>
                <div>
                    {
                        this.props.availableBudget &&
                            parseFloat(this.props.availableBudget) > 0 ?
                                <span>${this.props.availableBudget}</span> :
                                <span className="text-danger">${this.props.availableBudget}</span>
                    }
                </div>
            </div>
        );
    }
}

AvailableBudget.propTypes = {
    availableBudget: PropTypes.string
};

export default AvailableBudget;